import { useAction } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { reatomDisableMfa } from '@root/features/auth/setup-otp/atoms'
import { useBreakpoint } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { ConfirmDialog, ConfirmDrawer } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type SettingsSecurityConfirmProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
} & ClassNameProps

export const SettingsSecurityConfirm: React.FC<
  SettingsSecurityConfirmProps
> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()
  // eslint-disable-next-line @reatom/unit-naming-rule
  const disableMfaStateAtom = useMemo(() => reatomDisableMfa(), [])

  const removeOtp = useAction(disableMfaStateAtom.disable)

  const Cmp = breakpoint === 'mobile' ? ConfirmDrawer : ConfirmDialog

  return (
    <Cmp
      open={open}
      onOpenChange={onOpenChange}
      intent="error"
      title={t('mfa.remove-mfa-title')}
      describedBy={t('mfa.remove-mfa-title')}
      description={t('mfa.remove-mfa-confirm-message')}
      onConfirm={() => {
        removeOtp()
        // TODO: Use proper animation
        setTimeout(() => {
          onOpenChange(false)
        }, 500)
      }}
      onCancel={() => {
        onOpenChange(false)
      }}
    />
  )
}
